module.exports = "<div class=\"renderer-container\">\r\n    <span class=\"renderer-default\">{{ cellDisplayValue }}</span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inventory/pallet-management/pallet-management-inventory/account-num-cell-renderer/account-num-cell-renderer.component.html
// module id = ../../../../../src/app/features/inventory/pallet-management/pallet-management-inventory/account-num-cell-renderer/account-num-cell-renderer.component.html
// module chunks = main